import { useParams, Link } from 'react-router-dom'
import { PageFrame } from '@/components/layout/PageFrame'
import { MDXProvider } from '@mdx-js/react'
import { getDoc } from '@/content/docs/registry'
import { mdxComponents } from '@/components/docs/mdxComponents'
import { useFeature } from '@/hooks'

export function DocPage() {
  const params = useParams()
  const slug = params['*'] ?? ''
  const doc = getDoc(slug)

  // A page gated on a disabled feature is treated as not found.
  const featureOk = useFeature(doc?.feature ?? '__always__' /* unused when no feature */)
  const gatedOut = doc?.feature ? !featureOk : false

  if (!doc || doc.visibility === 'internal' || gatedOut) {
    return (
      <PageFrame width="form" className="py-8">
        <p className="text-muted-foreground">Help article not found.</p>
        <Link to="/help" className="text-primary underline">Back to Help</Link>
      </PageFrame>
    )
  }

  const { Component } = doc
  return (
    <PageFrame width="form">
      <article className="prose prose-slate max-w-none">
        <MDXProvider components={mdxComponents}>
          <Component />
        </MDXProvider>
      </article>
    </PageFrame>
  )
}
